import React from "react";
import { useLoading } from "./Loading";

const TermsAndConditions = () => {

    const {setLoading} = useLoading();
    setLoading(false);

    return (
        <div style={{marginTop:"15px"}}>
            <h2 style={{marginBottom:"15px"}}>Terms & Conditions (T&C) for Pawtner</h2>
            <div style={{display:"flex", flexDirection:"column", width:"90%", justifySelf:"center", alignContent:"center", textAlign:"justify"}}>
            <p>
                <strong>1. Acceptance of Terms:</strong> <br/>

                By registering and using our pet adoption system ("System"), you ("User") agree to be bound by these Terms & Conditions ("Terms"). If you do not agree with any part of these Terms, you must not use the System.
                </p>
                <p>
                <strong>2. User Accounts:</strong><br/>

                Registration: Users must provide accurate and complete information during registration.<br/>
                Account Responsibility: Users are responsible for maintaining the confidentiality of their account credentials.<br/>
                Account Termination: We reserve the right to terminate or suspend user accounts for violations of these Terms.
                </p>
                <p>
                <strong>3. Use of the System:</strong><br/>

                Purpose: The System is intended to facilitate pet adoptions.
                Accuracy of Information: Users are responsible for ensuring the accuracy of information provided about pets.
                Prohibited Activities: Users must not use the System for illegal or unethical purposes, including but not limited to:
                Misrepresenting pets.
                Engaging in animal cruelty.
                Facilitating illegal pet sales.
                Adoption Process: The pet adoption process, including screening and approval, is subject to our discretion and policies.
                Health of Pets: We do not guarantee the health or temperament of adopted pets. Adopters are responsible for veterinary care.
                </p>
                <p>
                <strong>4. Limitation of Liability:</strong><br/>

                We are not liable for any damages arising from the use of the System or the adoption of pets.
                We make no warranties regarding the availability or accuracy of the System.
                </p>
                <p>
                <strong>5. No Multiple Identities/Accounts:</strong><br/>
                Each user can only maintain ONE (1) identity/account/username. If you need to create a new identity because of lost password, username or e-mail address, older identities cannot be used anymore.
                </p>
                <p>
                <strong>6. Changes to Terms:</strong><br/>

                We reserve the right to modify these Terms at any time. Users will be notified of changes via email or through the System.
                </p>
                <p>
                <strong>7. Contact Information:</strong> <br/>

                For questions regarding these Terms, please contact us at <a href="mailto:pawtner1234@gmail.com">pawtner1234@gmail.com</a>.
            </p>

            </div>
           
        </div>
    )
};

export default TermsAndConditions;